import { useSearchPageBannersData } from "@faire/retailer-visitor-shared/components/Banners/DataFetching/useSearchPageBannersData";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { useGetItemsPerRowResponsive } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
import { MAX_PRODUCTS_PER_FILTERED_SECTION } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/DiscoverPageFilteredProductGrids/DiscoverPageFilteredProductGrids";
import { SearchPageExactProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/SearchPageExactProductResults/SearchPageExactProductResults";
import { useSearchPageSlicedProducts } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
import { useSearchPageIrrelevantProducts } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageIrrelevantProducts";
import { useSearchPageOrganicRelevanceClassification } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageorganicRelevanceClassification";
import { useDiscoverPageShouldShowTopProducts } from "@faire/retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import React from "react";

interface IProps {
  title: string;
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}

export const SearchPageProductResults: React.FC<IProps> = ({
  title,
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("SearchPageProductResults");

  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);
  const { displayableBannersWithAdjustedRow } = useSearchPageBannersData();
  const products = useSearchPageSlicedProducts();
  const irrelevantProducts = useSearchPageIrrelevantProducts();
  const organicRelevanceClassification =
    useSearchPageOrganicRelevanceClassification();
  const itemsPerRowResponsive = useGetItemsPerRowResponsive(isSideBarVisible);
  const itemsPerRow = useResponsiveValue(itemsPerRowResponsive);
  const numOfSearchResultRows = Math.round(
    (products?.length ?? 0) / itemsPerRow
  );

  const itemsPerFilteredSection = useResponsiveValue(
    MAX_PRODUCTS_PER_FILTERED_SECTION
  );
  const shouldShowTopProducts = useDiscoverPageShouldShowTopProducts();
  const remainingProducts = shouldShowTopProducts
    ? products?.slice(itemsPerFilteredSection)
    : products;

  const mainResultsBanners =
    displayableBannersWithAdjustedRow(
      itemsPerRow,
      remainingProducts?.length ?? 0
    ) ?? [];
  let alternateResultsBanners =
    displayableBannersWithAdjustedRow(itemsPerRow, 0) ?? [];
  const mainSectionHasBannerInTheLastRow = mainResultsBanners.some(
    (banner) => banner.row === numOfSearchResultRows + 1
  );
  if (mainSectionHasBannerInTheLastRow) {
    // in this case don't show a banner in the first row of the alternate results section:
    alternateResultsBanners = alternateResultsBanners.filter(
      (banner) => banner.row !== 1
    );
  }

  return (
    <>
      <SearchPageExactProductResults
        title={title}
        products={remainingProducts}
        irrelevantProducts={irrelevantProducts}
        organicRelevanceClassification={organicRelevanceClassification}
        bannerData={mainResultsBanners}
        searchPageLoadTimingRef={searchPageLoadTimingRef}
      />
      <Spacer height="1x" />
    </>
  );
};
